import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Loader } from '../../../components/common';
import { dictionary } from '../../../lang';
import AreaTeamPanel from './AreaTeamPanel';
/**
 * @param {Array<import('../../../redux').AreaTeamDetails>} teams
 * @param {boolean} loading
 */
const AreaTeams = ({ teams, loading, }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [openClose, setOpenClose] = useState({});
    const updateTeamSelection = (team, isSelected) => {
        const updatedOpenClose = { ...openClose };
        updatedOpenClose[team.id] = isSelected;
        setOpenClose(updatedOpenClose);
        let isExpanded = true;
        for (const isOpen of Object.values(updatedOpenClose)) {
            if (!isOpen) {
                isExpanded = false;
            }
        }
        setIsExpanded(isExpanded);
    };
    // TODO: wrap with useCallback/useStableCallback
    const collapseAll = () => {
        setOpenClose(teams.reduce((acc, { id }) => ({ ...acc, [id]: false }), {}));
        setIsExpanded(false);
    };
    // TODO: wrap with useCallback/useStableCallback
    const expandAll = () => {
        setOpenClose(teams.reduce((acc, { id }) => ({ ...acc, [id]: true }), {}));
        setIsExpanded(true);
    };
    useEffect(() => {
        collapseAll();
    }, [teams]); // TODO: add collapseAll to deps after wrapping with useCallback/useStableCallback
    return (_jsxs("div", { children: [_jsxs("div", { className: "flex justify-between h-[41px] rounded-t-lg border-x border-b p-1.5 pt-3", children: [_jsx("div", { className: "text-sm font-bold pl-1.5", children: "Teams" }), _jsx("div", { className: "text-primary-300 text-[0.65rem] pt-1 pr-1.5", children: isExpanded ? (_jsx("button", { type: "button", onClick: collapseAll, onTouchStart: collapseAll, children: dictionary.COLLAPSE_ALL })) : (_jsx("button", { type: "button", onClick: expandAll, onTouchStart: expandAll, children: dictionary.EXPAND_ALL })) })] }), _jsx("div", { className: "w-[280px] max-h-[574px] rounded-b-lg overflow-auto", children: loading ? (_jsx(Loader, { className: "my-3.5" })) : (teams.map((team) => (_jsx(AreaTeamPanel, { team: team, openClose: Boolean(openClose[team.id]), updateTeamSelection: updateTeamSelection }, team.id)))) })] }));
};
AreaTeams.propTypes = {
    teams: PropTypes.array,
    loading: PropTypes.bool,
};
export default AreaTeams;
